
@if (!state.orderPayload()){
  <div class="orders-panel-message">
    <app-horus-message-general nameIcon="searchIcon">Aquí aparecerá la data correspondiente<br>a &lt;Pedidos&gt; del cliente.</app-horus-message-general>
  </div>
} @else if (state.isLoading()) {
  <div class="orders-panel-message">
    <app-horus-loading></app-horus-loading>
  </div>
} @else if (state.error()) {
  <div class="orders-panel-message">
    <app-horus-message-general nameIcon="errorIcon">Hubo un error al traer la información,<br>inténtalo nuevamente dando click en Buscar</app-horus-message-general>
  </div>
} @else if (!state.hasResults()) {
  <div class="orders-panel-message max-w-[237px] mx-auto">
    <app-horus-message-general nameIcon="noDataIcon">Sin información de Pedidos.<br>Prueba buscar en otra empresa u otro rango de fechas.</app-horus-message-general>

  </div>
} @else {
  <div class="orders-panel" data-tour="orders-panel">
    <div class="orders-panel__filter">
      <div class="orders-panel__filter__status" data-tour="order-filter-status">
        <div class="orders-panel__filter__status__title">
          Filtrar por:
        </div>
        <mat-button-toggle-group [hideSingleSelectionIndicator]="true" #statusFilterToggleGroup name="ordersPanelStatusFilter"
          aria-label="Estado del pedido" [value]="''" (change)="onStatusChange($event.value)">
          <mat-button-toggle value="">Todos</mat-button-toggle>
          <mat-button-toggle value="IN_PROGRESS">En curso</mat-button-toggle>
          <mat-button-toggle value="DELIVERED">Completados</mat-button-toggle>
          <mat-button-toggle value="CANCELED">Cancelados</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div class="orders-panel__filter__right">
        <div class="orders-panel__filter__compact-view" data-tour="order-compact-view">
          <span>Vista compacta</span>
          <app-switch
              class="example-margin"
              [value]="isOpen()"
              (valueChange)="toggle()">
          </app-switch>
        </div>
        <div class="orders-panel__filter__type" data-tour="order-filter-type">
          <mat-form-field appearance="outline">
            <mat-label>Tipo de compra</mat-label>
            <mat-select [value]="''" (selectionChange)="onOrderTypeChange($event.value)">
              <mat-option value="">Todos </mat-option>
              <mat-option value="EC">E-commerce </mat-option>
              <mat-option value="TD">Tienda física</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="orders-panel__list">
      @if (state.filteredOrders().length === 0) {
        <div class="orders-panel__list__empty">
          <app-horus-message-general nameIcon="noDataIcon" idBtnAction="order-detail-panel-error-btn-no-data">No hay información de pedidos &lt;{{ getReadableStatus() }}&gt; <br>Prueba buscar en las otras pestañas.</app-horus-message-general>
        </div>
      } @else {
        @for (order of state.filteredOrders(); track order.orderGroup; let i = $index) {
          <app-order-accordion
            [attr.data-tour]="i === 0 ? 'order-first-item' : null"
            [tenantId]="state.orderPayload()?.tenantId || ''"
            [order]="order"
            [isExpanded]="i === 0 || !isOpen()">
          </app-order-accordion>
        }
      }
    </div>
  </div>
}
